// https://app.growthbook.io/features/mccerts-2138-painted-door-v2
export const PAINTED_DOOR_V2_FLAG = 'mccerts-2138-painted-door-v2'
